import React from "react";
import usePageMeta from "@/hooks/usePageMeta";
import { useI18n } from "@/i18n";
import { PageHero } from "@/components/PageHero";
import { ASSETS } from "@/data/content";
import WorkationSection from "@/components/sections/Workation";
import Directions from "@/components/sections/Directions";

export default function Workation() {
  const { t } = useI18n();
  usePageMeta(t.meta.workation.title, t.meta.workation.desc);
  return (
    <>
      <PageHero
        image={ASSETS.atmPanorama}
        alt={t.pageHero.workation.alt}
        title={t.pageHero.workation.title}
        subtitle={t.pageHero.workation.subtitle}
        heightClass="h-[62svh] min-h-[460px] md:h-[74svh]"
      />
      <WorkationSection />
      <Directions />
    </>
  );
}
